import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const SLIDES = [
  { icon:"✈️", tag:"Air Ticketing",      h:"Book Flights\nWorldwide",    p:"Access 450+ airlines with real-time GDS fares. Domestic & international booking for all clients.", bg:"https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1400&q=80" },
  { icon:"🏨", tag:"Hotel Reservations", h:"Premium Hotels\nBest Rates", p:"Over 1.2 million properties globally. From budget stays to 5-star luxury — best B2B rates.",      bg:"https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1400&q=80" },
  { icon:"🛂", tag:"Visa Processing",    h:"Hassle-Free\nVisa Services", p:"End-to-end visa assistance for 180+ countries. Tourist, business, student & transit visas.",       bg:"https://images.unsplash.com/photo-1530521954074-e64f6810b32d?w=1400&q=80" },
  { isBanner:true, bg:"/network-banner.png" },
];

export default function LoginPage({ navigate }) {
  const { login } = useAuth();
  const [cur,      setCur]      = useState(0);
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState(null);
  const [loading,  setLoading]  = useState(false);

  useEffect(() => {
    const t = setInterval(() => setCur(c => (c+1)%SLIDES.length), 4500);
    return () => clearInterval(t);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const err = await login(email, password);
    if (err) { setError(err); setLoading(false); }
  };

  const S = SLIDES[cur];

  return (
    <div className="login-grid" style={{display:"grid",gridTemplateColumns:"1fr 430px",height:"100vh",overflow:"hidden",fontFamily:"'DM Sans',sans-serif"}}>
      <style>{`
        @keyframes zoomIn{from{transform:scale(1)}to{transform:scale(1.08)}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:translateY(0)}}
        @keyframes pulse{0%,100%{box-shadow:0 0 8px #4CAF50}50%{box-shadow:0 0 18px #4CAF50}}
        .inp:focus{border-color:#4a7fb5 !important;background:#fff !important;box-shadow:0 0 0 4px rgba(74,127,181,0.1) !important;}
        .login-btn:hover{opacity:0.92;transform:translateY(-1px);box-shadow:0 6px 20px rgba(74,127,181,0.35);}
        .link-a:hover{text-decoration:underline;}
        @media (max-width:900px){
          .login-grid{grid-template-columns:1fr !important;height:auto !important;min-height:100vh !important;overflow:visible !important;}
          .login-left{display:none !important;}
          .login-right{padding:32px 22px !important;}
        }
        @media (max-width:380px){
          .login-right{padding:26px 16px !important;}
          .login-links{gap:14px !important;}
        }
      `}</style>

      {/* ── LEFT SLIDER ── */}
      <div className="login-left" style={{position:"relative",overflow:"hidden",background:S.isBanner?"#eef2f8":"#0d1f3c"}}>
        <div key={cur} style={{position:"absolute",inset:0,backgroundImage:`url('${S.bg}')`,backgroundSize:S.isBanner?"contain":"cover",backgroundPosition:"center",backgroundRepeat:"no-repeat",animation:"zoomIn 10s ease forwards"}}>
          {!S.isBanner && (
            <div style={{position:"absolute",inset:0,background:"linear-gradient(160deg,rgba(5,12,30,0.68) 0%,rgba(5,12,30,0.28) 45%,rgba(5,12,30,0.88) 100%)"}}/>
          )}
        </div>

        {!S.isBanner && (
          <>
            {/* TOP LOGO — BIG */}
            <div style={{position:"absolute",top:32,left:44,zIndex:10}}>
              <img src="/logo-big.png" alt="AIHOVI B2B" style={{height:78,filter:"drop-shadow(0 2px 16px rgba(0,0,0,0.5))",objectFit:"contain"}}/>
            </div>

            {/* SERVICES STRIP */}
            <div style={{position:"absolute",top:36,right:0,display:"flex",flexDirection:"column",gap:2,zIndex:10}}>
              {["✈ Air Tickets","🏨 Hotels","🛂 Visas"].map(s=>(
                <div key={s} style={{background:"rgba(74,127,181,0.18)",borderLeft:"2px solid #4a7fb5",padding:"6px 18px",fontSize:10,letterSpacing:2,color:"#b8d0e8",textTransform:"uppercase"}}>{s}</div>
              ))}
            </div>

            {/* SLIDE CONTENT */}
            <div style={{position:"absolute",bottom:0,left:0,right:0,padding:"52px 56px",zIndex:5}} key={"c"+cur}>
              <div style={{fontSize:68,marginBottom:18,animation:"fadeUp 0.7s 0.2s both",filter:"drop-shadow(0 4px 20px rgba(74,127,181,0.6))"}}>{S.icon}</div>
              <div style={{fontSize:11,fontWeight:600,letterSpacing:4,textTransform:"uppercase",background:"linear-gradient(135deg,#4a7fb5,#d4736a)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text",marginBottom:10,animation:"fadeUp 0.7s 0.35s both"}}>{S.tag}</div>
              <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:44,fontWeight:700,color:"#f8f5ef",lineHeight:1.1,marginBottom:14,whiteSpace:"pre-line",animation:"fadeUp 0.7s 0.45s both"}}>{S.h}</h2>
              <p style={{fontSize:14,color:"#8a9bb5",lineHeight:1.75,maxWidth:480,animation:"fadeUp 0.7s 0.55s both"}}>{S.p}</p>
            </div>
          </>
        )}

        {/* DOTS */}
        <div style={{position:"absolute",bottom:36,left:56,display:"flex",gap:8,zIndex:10}}>
          {SLIDES.map((_,i)=>(
            <button key={i} onClick={()=>setCur(i)} style={{width:i===cur?24:6,height:6,borderRadius:i===cur?3:"50%",background:i===cur?"#4a7fb5":"rgba(255,255,255,0.35)",border:"none",cursor:"pointer",padding:0,transition:"all 0.35s"}}/>
          ))}
        </div>
      </div>

      {/* ── RIGHT LOGIN PANEL ── */}
      <div className="login-right" style={{background:"#ffffff",display:"flex",flexDirection:"column",justifyContent:"safe center",padding:"40px 42px",position:"relative",overflowY:"auto"}}>
        {/* LEFT GRADIENT BAR */}
        <div style={{position:"absolute",top:0,left:0,width:3,height:"100%",background:"linear-gradient(180deg,#4a7fb5,#8a9fc4,#d4736a)"}}/>

        {/* SMALL LOGO */}
        <div style={{textAlign:"center",marginBottom:16}}>
          <img src="/logo-small.png" alt="AIHOVI B2B" style={{height:62,objectFit:"contain",filter:"drop-shadow(0 2px 8px rgba(0,0,0,0.08))"}}/>
        </div>

        {/* HEADING */}
        <div style={{textAlign:"center",marginBottom:22}}>
          <h1 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:27,fontWeight:700,color:"#0d1f3c",marginBottom:5}}>Agent Portal Sign In</h1>
          <p style={{fontSize:12,color:"#6b7a90",lineHeight:1.6}}>Authorized travel agents & partners only<br/>airhotelvisa.com — India's Premier B2B Travel Platform</p>
        </div>

        {/* AGENT STATUS CARD */}
        <div style={{background:"linear-gradient(135deg,#0d1f3c,#162844)",borderRadius:13,padding:"13px 18px",marginBottom:20,display:"flex",alignItems:"center",gap:13,border:"1px solid rgba(74,127,181,0.25)"}}>
          <div style={{width:38,height:38,background:"linear-gradient(135deg,#4a7fb5,#d4736a)",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:17,flexShrink:0}}>🤝</div>
          <div style={{flex:1}}>
            <span style={{display:"block",fontSize:10,letterSpacing:2,textTransform:"uppercase",color:"#4a7fb5"}}>B2B Agent Access</span>
            <strong style={{fontSize:13,color:"#f8f5ef",fontWeight:500}}>Secure Partner Portal</strong>
          </div>
          <div style={{width:8,height:8,background:"#4CAF50",borderRadius:"50%",flexShrink:0,animation:"pulse 2s infinite"}}/>
        </div>

        {/* ERROR */}
        {error && (
          <div style={{background:"rgba(224,82,82,0.08)",border:"1px solid #e05252",color:"#e05252",padding:"10px 14px",borderRadius:8,fontSize:13,marginBottom:14}}>⚠ {error}</div>
        )}

        {/* FORM */}
        <form onSubmit={handleSubmit} autoComplete="off">
          {[
            {label:"Agent Email ID", type:"email",    val:email,    set:setEmail,    icon:"📧", ph:"Enter your email address"},
            {label:"Password",       type:"password",  val:password, set:setPassword, icon:"🔒", ph:"Enter your password"},
          ].map(f=>(
            <div key={f.label} style={{marginBottom:15}}>
              <label style={{display:"block",fontSize:11,fontWeight:600,letterSpacing:"1.5px",textTransform:"uppercase",color:"#5a6a80",marginBottom:6}}>{f.label}</label>
              <div style={{position:"relative"}}>
                <span style={{position:"absolute",left:13,top:"50%",transform:"translateY(-50%)",fontSize:15,pointerEvents:"none"}}>{f.icon}</span>
                <input type={f.type} value={f.val} onChange={e=>f.set(e.target.value)} placeholder={f.ph} required autoComplete="new-password" className="inp"
                  style={{width:"100%",padding:"12px 14px 12px 40px",border:"1.5px solid #dde3ed",borderRadius:10,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:"#0d1f3c",background:"#fafbfd",outline:"none",boxSizing:"border-box",transition:"all 0.2s"}}/>
              </div>
            </div>
          ))}

          <button type="submit" disabled={loading} className="login-btn"
            style={{width:"100%",padding:"13px",background:"linear-gradient(135deg,#4a7fb5,#d4736a)",color:"#fff",fontFamily:"'DM Sans',sans-serif",fontSize:14,fontWeight:600,letterSpacing:1,border:"none",borderRadius:10,cursor:"pointer",marginTop:4,transition:"all 0.25s",opacity:loading?0.8:1}}>
            {loading ? "Verifying..." : "ACCESS PORTAL →"}
          </button>
        </form>

        {/* LINKS */}
        <div className="login-links" style={{display:"flex",justifyContent:"center",flexWrap:"wrap",gap:28,marginTop:16,marginBottom:16,padding:"12px 0",borderTop:"1px solid #eaeef5"}}>
          <a onClick={()=>navigate("forgot")}   className="link-a" style={{fontSize:12,color:"#4a7fb5",cursor:"pointer",textDecoration:"none"}}>🔑 Forgot Password?</a>
          <a onClick={()=>navigate("register")} className="link-a" style={{fontSize:12,color:"#4a7fb5",cursor:"pointer",textDecoration:"none"}}>✍ Register as Agent</a>
        </div>

        <div style={{textAlign:"center",fontSize:10,letterSpacing:2,color:"#b0b8c8",textTransform:"uppercase",marginTop:14}}>www.airhotelvisa.com · B2B Travel Portal · India</div>
        <div style={{textAlign:"center",fontSize:12,marginTop:8}}>
          <a href="mailto:airhotelvisa@gmail.com" style={{color:"#8a9fc4",textDecoration:"none",fontWeight:500}}>✉ airhotelvisa@gmail.com</a>
        </div>
        <div style={{textAlign:"center",fontSize:11,color:"#c3cad8",marginTop:10}}>Developed by <a href="https://www.websignx.com" target="_blank" rel="noreferrer" style={{color:"#8a9fc4",textDecoration:"none",fontWeight:600}}>www.websignx.com</a></div>
      </div>
    </div>
  );
}
